var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.lastPageBtnIsShow)?_c('button',{staticClass:"lastPage",on:{"click":function($event){return _vm.$emit('click')}}},[_c('leftArrowIcon',{staticClass:"lastPage__icon"})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }